import type { TriggerDefinition } from "@butler/shared";
import { z } from "zod";

const cronTriggerParametersSchema = z.object({
  name: z.literal("cron"),
  parameters: z.object({
    frequency: z.enum(["daily", "weekly", "monthly", "yearly"]),
    time: z.string(),
    end_date: z.string().optional(),
  }),
});

export type CronTriggerParameters = z.infer<typeof cronTriggerParametersSchema>;

export const cronTrigger: TriggerDefinition<"cron", CronTriggerParameters> = {
  name: "cron",
  type: "automatic",
  description: `
Set up a cron job to repeat the workflow at a specific frequency and time.
type CronTriggerParameters = {
  frequency: "daily" | "weekly" | "monthly" | "yearly";
  time: string;
  end_date: string | undefined;
}
  `,
  schema: cronTriggerParametersSchema,
  validator: (value: CronTriggerParameters) => {
    return cronTriggerParametersSchema.safeParse(value).success;
  },
};
